let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ktmsN")).then(() => parcelRequire('dHCVo'));